export class MaterialCategory {
  _id: string;
  name: string;
  subCategories: any;
  createdAt: Date;
  updatedAt: Date;

  hasSearchTerms; // For filters
  categories: any; // For filters
  sub_category_name: string; // For filters
  dateCreatedRange; // For filters
  dateCreated; // For filters
  dateCreatedEnd; // For filters
}
